import {
  InputOnChangeData,
  makeStyles,
  SearchBox,
  SearchBoxChangeEvent,
} from "@fluentui/react-components";
import { useSearchParams } from "react-router-dom";

interface VsaSearchBoxProps {
  placeholder: string;
  onSearch: (value: string) => void;
  defaultValue?: string; // Note: Setting a default value will take priority over the query parameter if it exists.
  disableQueryParameter?: boolean;
}

const useStyles = makeStyles({
  searchInput: {
    width: "300px",
  },
});

export const VsaSearchBox = (props: VsaSearchBoxProps) => {
  const { placeholder, onSearch, defaultValue, disableQueryParameter } = props;
  const classes = useStyles();

  const [searchParams, setSearchParams] = useSearchParams();

  const searchQuery = defaultValue
    ? defaultValue
    : disableQueryParameter
      ? ""
      : (searchParams.get("query") ?? "");

  const handleChange = (
    event: SearchBoxChangeEvent,
    data: InputOnChangeData
  ) => {
    if (event.type !== "click" || data.value) {
      return;
    }

    handleSearch("");
  };

  const handleSearch = (value: string) => {
    if (!disableQueryParameter) {
      searchParams.delete("page"); // Resets the page to one on a new search.

      if (value) {
        searchParams.set("query", value);
      } else {
        searchParams.delete("query");
      }

      setSearchParams(searchParams, {
        preventScrollReset: true,
      });
    }

    onSearch(value);
  };

  return (
    <SearchBox
      className={classes.searchInput}
      placeholder={placeholder}
      defaultValue={searchQuery}
      onChange={handleChange}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          handleSearch(e.currentTarget.value);
        }
      }}
      onSubmit={(e) => {
        e.preventDefault();
        handleSearch(e.currentTarget.value);
      }}
    />
  );
};
